import React from "react";
import PropTypes from 'prop-types';
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {

  let location = useLocation();
  const token = window.localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }
  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
